import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

/**
 * ドキュメントタイプ識別子スライス
 * Resume（職務経歴書）とRirekisho（履歴書）を切り替える
 */

type DocumentType = 'resume' | 'rirekisho';

type DocumentTypeState = {
  /** 現在のドキュメントタイプ */
  currentType: DocumentType;
};

const initialState: DocumentTypeState = {
  currentType: 'resume',
};

const documentTypeSlice = createSlice({
  name: 'documentType',
  initialState,
  reducers: {
    setDocumentType(state: DocumentTypeState, action: PayloadAction<DocumentType>) {
      state.currentType = action.payload;
    },
    toggleDocumentType(state: DocumentTypeState) {
      state.currentType = state.currentType === 'resume' ? 'rirekisho' : 'resume';
    },
  },
});

// Selectors
const _selectDocumentType = (state: RootState) => state.documentType.currentType;
const _selectIsResume = (state: RootState) => state.documentType.currentType === 'resume';
const _selectIsRirekisho = (state: RootState) => state.documentType.currentType === 'rirekisho';

export default documentTypeSlice.reducer;
